export const initialState = {
    is_loading: true,
    ftm: {},
    ftm_profile_image: null,
    search_value: null,
    address_details: {},
    is_loading_address_detail: false,
    is_ftm_updating: false,
}